module.exports = __webpack_public_path__ + "img/img11.7cc58961.svg";